import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "column field" };
const _hoisted_2 = { style: { "display": "flex" } };
const _hoisted_3 = {
    key: 0,
    class: "label"
};
const _hoisted_4 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_5 = { class: "control" };
const _hoisted_6 = ["type", "value", "maxlength", "disabled", "placeholder", "autocomplete"];
import { trimString } from "@/core/utils";
import { onMounted, ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormTextField',
    props: {
        modelValue: {},
        label: {},
        description: {},
        placeholder: {},
        isPassword: { type: Boolean },
        trimmed: { type: Boolean },
        numeric: { type: Boolean },
        length: {},
        validator: { type: Function },
        validationId: {},
        isDisabled: { type: Boolean },
        autoFocus: { type: Boolean },
        noAutoFill: { type: Boolean }
    },
    emits: ['update:modelValue', 'enter'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        // The input element where the form field's value will be bound
        const inputElem = ref(null);
        // Event for two-way binding
        const emit = __emit;
        const onInput = (isBlur) => {
            let val = inputElem.value.value;
            if (isBlur && props.trimmed) {
                val = trimString(val);
            }
            if (props.numeric) {
                val = val.replaceAll(/[^0-9]/g, '');
            }
            inputElem.value.value = val;
            emit('update:modelValue', val);
        };
        onMounted(() => {
            if (props.autoFocus) {
                inputElem.value.focus();
            }
            if (props.trimmed && trimString(props.modelValue) != props.modelValue) {
                emit('update:modelValue', trimString(inputElem.value.value));
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_ctx.label)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_ctx.label), 1))
                        : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "top")
                ]),
                (_ctx.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.description), 1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("input", {
                        ref_key: "inputElem",
                        ref: inputElem,
                        class: _normalizeClass(["input", { 'is-danger': _ctx.validator ? !_ctx.validator(_ctx.validationId ? _ctx.validationId : this, _ctx.modelValue) : false }]),
                        type: _ctx.isPassword ? 'password' : 'text',
                        value: _ctx.modelValue,
                        maxlength: _ctx.length,
                        onInput: _cache[0] || (_cache[0] = ($event) => (onInput(false))),
                        onBlur: _cache[1] || (_cache[1] = ($event) => (onInput(true))),
                        onKeyup: _cache[2] || (_cache[2] = _withKeys(($event) => (emit('enter')), ["enter"])),
                        disabled: _ctx.isDisabled,
                        placeholder: _ctx.placeholder,
                        autocomplete: _ctx.noAutoFill ? 'new-password' : ''
                    }, null, 42, _hoisted_6),
                    _renderSlot(_ctx.$slots, "default")
                ])
            ]));
        };
    }
});
